import { atom, selector } from 'recoil'
import Decimal from 'decimal.js'
import { TOKEN_BALANCE } from '@/constants/wallet'

export const tokenListState = atom({
  key: 'TokenList',
  default: []
})

export const walletState = atom({
  key: 'Wallet',
  default: {}
})

export const _accountWalletState = atom({
  key: '_AccountWallet',
  default: {}
})

export const showWalletBalanceState = atom({
  key: 'ShowWalletBalance',
  default: true
})

export const accountWalletState = selector({
  key: 'AccountWallet',
  get: ({ get }) => get(_accountWalletState),
  set: ({ get, set }, { tokenBalanceData, isReset = false }) => {
    const walletMap = JSON.parse(JSON.stringify(get(_accountWalletState)))

    if (tokenBalanceData?.length) {
      // data from RESTful API
      tokenBalanceData.forEach(({ token, holding, frozen, pending_short }) => {
        if (!walletMap[token]) {
          walletMap[token] = { ...TOKEN_BALANCE }
        }

        const pendingShortQty = Decimal(pending_short).abs().toNumber()
        walletMap[token].holding = holding
        walletMap[token].frozen = frozen
        walletMap[token].pendingShortQty = pendingShortQty
        walletMap[token].available = Decimal(holding)
          .sub(pendingShortQty)
          .toNumber()
      })
    } else {
      // data from WebSocket API
      Object.keys(tokenBalanceData).forEach(symbol => {
        delete tokenBalanceData[symbol].version
        tokenBalanceData[symbol].pendingShortQty = Decimal(
          tokenBalanceData[symbol].pendingShortQty
        )
          .abs()
          .toNumber()
        walletMap[symbol] = tokenBalanceData[symbol]
        const { holding, pendingShortQty } = walletMap[symbol]
        walletMap[symbol].available = Decimal(holding)
          .sub(pendingShortQty)
          .toNumber()
      })
    }

    set(_accountWalletState, walletMap)
  },
  cachePolicy_UNSTABLE: {
    eviction: 'most-recent'
  }
})
